import { todayStr, thisMonthStr, halalBucket } from "./constants";

// ── DEMO SEEDER ───────────────────────────────────────────────
function buildDemoData() {
  // Ahmed Al-Farsi — Canadian Muslim, software developer, $82k/yr
  // Has: TD Visa credit card debt, car loan, Hajj savings goal, a full year of transactions

  const id = () => Date.now() + Math.floor(Math.random() * 1e9);

  // ── TRANSACTIONS — Jan 2025 → Mar 2026 ──────────────────────
  const txns = [];
  const push = (date, desc, amount, expCat, icon, cardId=null, recurringId=null) => {
    txns.push({ id:id(), date, description:desc, amount, expenseCategory:expCat,
      category: amount>0 ? "Income" : (halalBucket[expCat]||"Want"),
      icon, cardId, recurring: !!recurringId, recurringId });
  };

  const months = [
    "2025-01","2025-02","2025-03","2025-04","2025-05","2025-06",
    "2025-07","2025-08","2025-09","2025-10","2025-11","2025-12",
    "2026-01","2026-02","2026-03",
  ];

  // Credit card ID (will match debt below)
  const CC_ID = 1700000001;
  const CAR_ID = 1700000002;

  // Fixed recurring IDs — must match the recurring array below
  const R_RENT    = 2000000001;
  const R_CAR     = 2000000002;
  const R_PHONE   = 2000000003;
  const R_NETFLIX = 2000000004;
  const R_SPOTIFY = 2000000005;
  const R_ADOBE   = 2000000006;
  const R_INSURE  = 2000000007;
  const R_SADAQAH = 2000000008;
  const R_HAJJ    = 2000000009;
  const R_SAL1    = 2000000010;
  const R_SAL2    = 2000000011;

  months.forEach((m, mi) => {
    const d = (day) => `${m}-${String(day).padStart(2,"0")}`;

    // ── INCOME (1st and 15th) ──────────────────────────────
    push(d(1),  "Salary - Accenture Canada", 3416.67,  "Other", "💰", null, R_SAL1);
    push(d(15), "Salary - Accenture Canada", 3416.67,  "Other", "💰", null, R_SAL2);

    // Freelance some months
    if ([1,3,5,8,10].includes(mi)) push(d(20), "Freelance - web project", 800, "Other", "💻");

    // ── FIXED MONTHLY (recurring) ──────────────────────────
    push(d(1),  "Rent - 2BR Mississauga",    -1650, "Rent",          "🏠", null, R_RENT);
    push(d(5),  "Rogers - Phone plan",        -89,  "Phone",         "📱", null, R_PHONE);
    push(d(7),  "Netflix",                    -18,  "Subscriptions", "📺", null, R_NETFLIX);
    push(d(7),  "Spotify",                    -12,  "Subscriptions", "📺", null, R_SPOTIFY);
    push(d(7),  "Adobe Creative Cloud",       -60,  "Subscriptions", "📺", null, R_ADOBE);
    push(d(10), "Enbridge Gas",               -95,  "Utilities",     "💡");
    push(d(10), "Toronto Hydro",              -68,  "Utilities",     "💡");
    push(d(20), "Car Insurance - Intact",    -185,  "Transport",     "🚗", null, R_INSURE);

    // ── GROCERIES ──────────────────────────────────────────
    push(d(3),  "Costco - bulk groceries",   -220,  "Groceries", "🛒", CC_ID);
    push(d(17), "Freshco",                   -85,   "Groceries", "🛒");
    push(d(25), "Halal meat market",          -60,  "Groceries", "🛒");

    // ── FOOD / DINING ──────────────────────────────────────
    push(d(2),  "Tim Hortons",               -7.50, "Coffee",    "☕");
    push(d(4),  "Tim Hortons",               -6.25, "Coffee",    "☕");
    push(d(8),  "Tim Hortons",               -8.00, "Coffee",    "☕");
    push(d(11), "Shawarma Palace",           -22,   "Food",      "🍔", CC_ID);
    push(d(13), "Tim Hortons",               -6.75, "Coffee",    "☕");
    push(d(16), "McDonald's",               -14.50, "Food",      "🍔", CC_ID);
    push(d(19), "Uber Eats - Pizza",         -38,   "Dining Out","🍽️", CC_ID);
    push(d(22), "Tim Hortons",               -9.25, "Coffee",    "☕");
    push(d(24), "Halal guys restaurant",     -28,   "Dining Out","🍽️");
    push(d(27), "Uber Eats - Biryani House", -45,   "Dining Out","🍽️", CC_ID);

    // ── TRANSPORT ──────────────────────────────────────────
    push(d(6),  "Petro-Canada - fuel",       -85,   "Transport", "🚗");
    push(d(18), "Petro-Canada - fuel",       -78,   "Transport", "🚗");
    push(d(12), "Presto transit card",       -55,   "Transport", "🚗");

    // ── HEALTH ─────────────────────────────────────────────
    if (mi % 2 === 0) push(d(9), "Shoppers - vitamins",  -35, "Health", "💊");
    if (mi % 3 === 0) push(d(14),"Dentist co-pay",       -80, "Health", "💊");

    // ── SADAQAH (charity each month) ────────────────────────
    push(d(1),  "Islamic Relief Canada",      -50,  "Sadaqah", "🤲", null, R_SADAQAH);
    if (mi === 2) push(d(1), "Ramadan charity - extra", -150, "Sadaqah", "🤲"); // Ramadan
    if (mi === 2) push(d(15),"Zakat payment",          -620, "Sadaqah", "🤲"); // Ramadan zakat
    if (mi % 4 === 0) push(d(20), "Local mosque donation", -25, "Sadaqah", "🤲");

    // ── HAJJ SAVINGS TRANSFER ─────────────────────────────
    push(d(28), "Hajj savings transfer",     -400,  "Other", "🕋", null, R_HAJJ);

    // ── SHOPPING (some months) ─────────────────────────────
    if (mi % 3 === 0) push(d(15),"Amazon.ca order",    -65,  "Shopping", "🛍️", CC_ID);
    if (mi % 4 === 1) push(d(22),"Walmart - household",-95,  "Shopping", "🛍️");
    if (mi === 7)     push(d(12),"Eid clothing - Zara",-320, "Shopping", "🛍️", CC_ID);  // Eid

    // ── EDUCATION ──────────────────────────────────────────
    if (mi === 0) push(d(15), "Udemy - React course",   -45, "Education", "🎓");
    if (mi === 5) push(d(10), "Islamic finance course",  -99, "Education", "🎓");

    // ── ENTERTAINMENT ──────────────────────────────────────
    if (mi % 2 === 1) push(d(18), "Cineplex - movie night", -42, "Entertainment", "🎮");

    // ── CAR LOAN PAYMENT ───────────────────────────────────
    push(d(1), "Toyota Financial - car loan", -480, "Other", "🚗", null, R_CAR);

    // ── CREDIT CARD MIN PAYMENT ────────────────────────────
    push(d(20), "TD Visa - payment",  300, "Other", "💳");
  });

  // ── DEBTS ─────────────────────────────────────────────────────
  // TD Visa — started at $4,200, making $300/mo payments but also charging to it
  // Car loan — 2022 Toyota Corolla, started $22,000 at 7.9% APR
  const debts = [
    {
      id: CC_ID,
      name: "TD Visa Infinite",
      type: "credit",
      originalBalance: 4200,
      currentBalance: 3180,   // paid some down over the year
      rate: 19.99,
      minPayment: 95,
    },
    {
      id: CAR_ID,
      name: "Toyota Financial - Corolla 2022",
      type: "car",
      originalBalance: 22000,
      currentBalance: 14280,  // ~$480/mo × 16 months paid
      rate: 7.9,
      minPayment: 480,
    },
  ];

  // Debt payments log
  const payments = months.map((m, i) => ({
    id: id(), debtId: CC_ID, amount: 300, month: m, note: "Monthly payment",
  }));
  // Also add car payments
  months.forEach((m, i) => {
    payments.push({ id: id(), debtId: CAR_ID, amount: 480, month: m, note: "Auto-pay" });
  });

  // ── RECURRING ────────────────────────────────────────────────
  const recurring = [
    { id:R_RENT,    name:"Rent", amount:1650, category:"Rent", icon:"🏠", color:"#a78bfa", dayOfMonth:1, type:"expense", active:true },
    { id:R_CAR,     name:"Car Loan Payment", amount:480, category:"Other", icon:"🚗", color:"#fbbf24", dayOfMonth:1, type:"expense", active:true },
    { id:R_PHONE,   name:"Rogers Phone", amount:89, category:"Phone", icon:"📱", color:"#38bdf8", dayOfMonth:5, type:"expense", active:true },
    { id:R_NETFLIX, name:"Netflix", amount:18, category:"Subscriptions", icon:"📺", color:"#f87171", dayOfMonth:7, type:"expense", active:true },
    { id:R_SPOTIFY, name:"Spotify", amount:12, category:"Subscriptions", icon:"📺", color:"#f87171", dayOfMonth:7, type:"expense", active:true },
    { id:R_ADOBE,   name:"Adobe CC", amount:60, category:"Subscriptions", icon:"📺", color:"#f87171", dayOfMonth:7, type:"expense", active:true },
    { id:R_INSURE,  name:"Car Insurance", amount:185, category:"Transport", icon:"🛡️", color:"#60a5fa", dayOfMonth:20, type:"expense", active:true },
    { id:R_SADAQAH, name:"Islamic Relief", amount:50, category:"Sadaqah", icon:"🤲", color:"#86efac", dayOfMonth:1, type:"expense", active:true },
    { id:R_HAJJ,    name:"Hajj Savings", amount:400, category:"Other", icon:"🕋", color:"#fbbf24", dayOfMonth:28, type:"expense", active:true },
    { id:R_SAL1,    name:"Salary - Accenture", amount:3416.67, category:"Other", icon:"💰", color:"#3dd68c", dayOfMonth:1, type:"income", active:true },
    { id:R_SAL2,    name:"Salary - Accenture", amount:3416.67, category:"Other", icon:"💰", color:"#3dd68c", dayOfMonth:15, type:"income", active:true },
  ];

  // ── GOALS ────────────────────────────────────────────────────
  // Hajj: $14,000 target. 15 months × $400 = $6,000 saved so far
  const goals = [
    {
      id: id(),
      name: "Hajj Fund",
      emoji: "🕋",
      target: 14000,
      saved: 6000,
      note: "Saving $400/month. In shaa Allah by 2027.",
      createdAt: "2025-01-01",
    },
    {
      id: id(),
      name: "Emergency Fund",
      emoji: "🌙",
      target: 10000,
      saved: 3200,
      note: "3–6 months of essential expenses",
      createdAt: "2025-01-01",
    },
    {
      id: id(),
      name: "Halal House Deposit",
      emoji: "🏠",
      target: 60000,
      saved: 8500,
      note: "Saving for a riba-free mortgage with Manzil",
      createdAt: "2025-01-01",
    },
  ];

  // ── ZAKAT ────────────────────────────────────────────────────
  // Ahmed's zakatable wealth as of March 2026
  const zakatData = {
    cash:        "1200",    // wallet + chequing buffer
    savings:     "",        // auto-pulled from goals
    gold:        "0",
    silver:      "0",
    investments: "",        // auto-pulled from investment transactions
    receivables: "500",     // friend owes him money
    business:    "0",
    liabilities: "",        // auto-pulled from ALL riba debts (CC + car loan)
  };

  // ── BUDGET ──────────────────────────────────────────────────
  // Ahmed earns ~$6,833/mo. Budget designed to show realistic mix:
  // ✅ Green: Rent, Groceries, Utilities, Sadaqah, Phone
  // ⚠️ Amber: Transport, Health, Shopping
  // 🔴 Red: Food/Dining Out (the relatable leak everyone has)
  // Subscriptions slightly over (another common one)
  const budgets = {
    "Rent":          1700,   // spends $1,650 → 97% ⚠️ nearly at limit
    "Groceries":     420,    // spends ~$365  → 87% ✅ good
    "Food":          80,     // spends ~$120  → 🔴 over (fast food habit)
    "Dining Out":    90,     // spends ~$110  → 🔴 over (UberEats is the killer)
    "Coffee":        40,     // spends ~$38   → 95% ⚠️ nearly there
    "Transport":     450,    // spends ~$400  → 89% ⚠️ close
    "Utilities":     200,    // spends $163   → 82% ✅ fine
    "Phone":         90,     // spends $89    → 99% ⚠️ exactly at limit
    "Subscriptions": 75,     // spends $90    → 🔴 over (Adobe alone is $60)
    "Health":        80,     // spends ~$35-115 → varies, often fine
    "Shopping":      120,    // spends varies → sometimes over
    "Sadaqah":       120,    // spends $50+   → 42% ✅ well under (room to give more)
    "Education":     60,     // occasional    → ✅
    "Entertainment": 60,     // occasional    → ✅
  };

  const budgetData = {
    income: 6833,
    budgets,
    allocs: [],  // not needed for demo
  };

  return { txns, debts, payments, recurring, goals, zakatData, budgetData };
}

export { buildDemoData };